<template>
	<div class="not-found">
		<div class="msg-box">
			<h1 class="animated fadeInDown">WIP</h1>
			<h2 class="animated fadeInUp">
				This page is not ready yet!<br>Clearly a devops problem.
			</h2>
		</div>
	</div>
</template>

<script>
export default {
	name: 'work-in-progress'
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';
@import '../../assets/scss/_mixins';

.msg-box {
	max-width: 400px;
	margin: 50px auto;

	h1 {
		@include text-bordered-shadow();
	}
}
</style>




// WEBPACK FOOTER //
// src/views/pages/WorkInProgress.vue